import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';

var Url = function () {
    function Url() {
        _classCallCheck(this, Url);
    }

    _createClass(Url, null, [{
        key: 'getParam',
        value: function getParam(url, name, defaultValue) {
            if (!url || !name) {
                return;
            }

            var regexp = new RegExp('[?&#]' + name + '=');
            var start = url.search(regexp);

            if (start < 0) {
                return defaultValue;
            }

            start += name.length + 2;

            var end = url.substr(start).search(/[?&#]/);

            return url.substr(start, end >= 0 ? end : undefined);
        }
    }, {
        key: 'removeParam',
        value: function removeParam(url, name) {
            if (url) {
                return url.replace(new RegExp('[?&#/]' + name + '=[^/&#]*', 'gi'), '');
            }
        }
    }, {
        key: 'paramsArray',
        value: function paramsArray(url) {
            if (!url) {
                return [];
            }

            var start = url.search(/[?#]/);

            if (start < 0) {
                return [];
            }

            var startQuestionMark = url.search(/[?]/, start);

            if (startQuestionMark >= 0) {
                start = startQuestionMark;
            }

            var end = url.substr(start + 1).search(/[#]/);

            return url.substr(start + 1, end < 0 ? undefined : end).replace(/[\/#?]/g, '').split('&');
        }
    }]);

    return Url;
}();

export default Url;


//////////////////
// WEBPACK FOOTER
// ./submodules/dialogloop-sdk-js/dist/Utils/Url.js
// module id = 503
// module chunks = 0